// extracted by mini-css-extract-plugin
module.exports = {"container":"OWNo-JhqksOSn4oJWLbNb","label":"_1G7h8kGxYCt5SHAWliz3Kx","containerIcon":"_20m7mdxd-bsZiE04e409gL","addressSelector":"_1wCQDS2mswBxGlqQ8a8N0l"};